import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classnames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { addResizeParams } from '../../utils/commonHelper';
import { listingPropTypes } from '../../utils/commonPropTypes';
import { getTitle } from '../../utils/listingHelper';
import DefaultImage from '../DefaultImage';

class ListingImage extends PureComponent {
  state = {
    imageError: false,
  };

  handleImageError() {
    this.setState({
      imageError: true,
      defaultImage: true
    });
  }

  render(){
    let { listing, lazyLoad, resize } = this.props;
    let listingMedia = get(listing, 'media', []);
    let images = listingMedia.filter((media) => {
      return media.mediaType === 'image';
    });
    let image = images[0];
    let title = getTitle(listing);
    return <>
      {
        image && !this.state.imageError ?
          <LazyLoadImage
            src={addResizeParams(image.url, resize, image.date.modified)}
            alt={title}
            onError={this.handleImageError.bind(this)}
            className={classnames('image-results', {'wide': image.width > 700})}
            visibleByDefault={!lazyLoad}
            threshold = {200}
            placeholder={<div className={classnames('preloader')}>{title}</div>}
          /> :
          <DefaultImage size="70" />
      }
    </>;
  }
}

ListingImage.defaultProps = {
  lazyLoad: false,
  listing: {},
  resize: {},
};

ListingImage.propTypes = {
  /** Make image visible by default */
  lazyLoad: PropTypes.bool,
  /** Listing information of the boat */
  listing: listingPropTypes,
  /** Resize specifications for the image */
  resize: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
};

export default (ListingImage);
